import React, {Component} from 'react';
import {Breadcrumb, Button, Popup} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import {Helmet} from "react-helmet";

import CustomDivider from '../../components/extras/CustomDivider';
import {connect} from "react-redux";
import localDB from "../../data/localDB";
import DynamicTable from "../../components/extras/DynamicTable";
import {dynamicTableAddOrUpdate, dynamicTableDelete} from "../../actions/DynamicTableDataAction";
import QuestionDialog from "../../components/extras/QuestionDialog";
import {showToast} from "../../actions/ToastAction";
import {selectRecipe} from "../../actions/RecipeSelectActions";
import RecipeDialog from "../../components/inventories/RecipeDialog";
import {recipeDialog} from "../../actions/RecipeDialogActions";
import RecipeData from "../../data/RecipeData";
import {openModalProductIngredients} from "../../actions/ModalProductIngredientsActions";
import RecipeIngredientsDialog from "../../components/inventories/RecipeIngredientsDialog";
import RecipeProductsPreMakeDialog from "../../components/inventories/RecipeProductsPreMakeDialog";
import {openModalRecipesProductsPreMake} from "../../actions/ModalRecipeProductsPreMakeActions";
import RecipeStock from "../../components/inventories/RecipeStock";
import CurrentStockRecipeModal from "../../components/inventories/CurrentStockRecipeModal";


class Recipes extends Component {

    constructor(props) {
        super(props);

        let more_actions = [
            this.actionIngredientsButton,
        ]

        this.state = {
            table: {
                headers: ['Nombre', 'Inventario', 'Acciones'],
                name: 'Receta',
                title: 'Recetas',
                has_actions: true,
                edit: true,
                images: false,
                can_add: true,
                pagination: true,
                delete: true,
                url: 'recipes',
                values: ['id', 'name', 'count_stock'],
                id: 'table_recipes',
                component_fields:[{count_stock:RecipeStock}],
                more_actions: more_actions,
            },
        };
        this.delete = this.delete.bind(this);
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.recipe_select && nextProps.recipe_select.hasOwnProperty('id')){
            localDB.addOrUpdateDB('products', {id:nextProps.recipe_select.id, name:nextProps.recipe_select.name});
            this.props.dynamicTableAddOrUpdate(nextProps.recipe_select);
        }
    }

    actionIngredientsButton = (data) => {
        return <Popup
            trigger={<Button icon='leaf' onClick={()=>this.props.openModalProductIngredients({is_open:true, name: data.name, id: data.id, loading:true})}/>}
            content='Ingredientes'
            position='top left'
            key={`button_ingredient_${data.id}`}
        />;
    }

    // ToDo delete
    actionProductsPreMakeButton = (data) => {
        return <Popup
            trigger={<Button icon='utensil spoon' onClick={()=>this.props.openModalRecipesProductsPreMake({is_open:true, name: data.name, id: data.id, loading:true})}/>}
            content='Productos Pre-Elaborados'
            position='top left'
            key={`button_pre_maker_${data.id}`}
        />;
    }

    showRecipes = (data) => {
        this.props.productRecipesDialog({id: data.id, name: data.name, is_open:true});
    }

    callbackDynamicTable = (response) => {
        if(response.event === 'add'){
            this.props.recipeDialog({
                open: true, recipe: {
                    id: null,
                    name: '',
                    is_active: true
                }
            });
        }else if(response.event === 'edit'){
            this.props.recipeDialog({open:true, recipe:response.data});
        }else if(response.event === 'delete'){
            this.refs.deleteDialog.open('', response.data.id);
        }else if(response.event === 'images'){
            this.refs.dialogImages.loadData(response.data.name, response.data.id);
        }
    };

    async delete(id) {
        RecipeData.delete(id, (res) => {
            if (res === null) {
                this.props.showToast({message: 'Receta borrada!', type: 'success'});
                this.props.dynamicTableDelete(id);
            } else {
                this.props.showToast({message: 'Esta receta está siendo utilizado por un producto!', type: 'error'});
            }
        });
    };

    render() {

        return (
            <div>
                <Helmet>
                    <title>Recetas | Invetarios - Bisttros</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/inventories'>Inventarios</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Recetas</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <DynamicTable {...this.state.table} callbackDynamicTable={this.callbackDynamicTable}/>
                <RecipeDialog/>
                <RecipeIngredientsDialog />
                <RecipeProductsPreMakeDialog />
                <QuestionDialog ref="deleteDialog" message="Borrar esta receta" callbackConfirm={this.delete}/>
                <CurrentStockRecipeModal />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        recipe_select: state.get('recipe_select'),
    };
}

function mapDispatchToProps(dispatch){
    return {
        recipeDialog(data){
            dispatch(recipeDialog(data))
        },
        dynamicTableAddOrUpdate(data){
            dispatch(dynamicTableAddOrUpdate(data))
        },
        dynamicTableDelete(data){
            dispatch(dynamicTableDelete(data))
        },
        showToast(data){
            dispatch(showToast(data))
        },
        selectRecipe(data) {
            dispatch(selectRecipe(data))
        },
        openModalProductIngredients(data){
            dispatch(openModalProductIngredients(data))
        },
        openModalRecipesProductsPreMake(data){
            dispatch(openModalRecipesProductsPreMake(data))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Recipes)



// WEBPACK FOOTER //
// ./src/containers/inventories/Recipes.js